var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.valid)?_c('transition',{attrs:{"name":"fade-in"}},[_c('div',{staticClass:"retail-notification"},[_c('InfoSvg'),_c('span',[_vm._v(_vm._s(_vm.$store.getters.translate(_vm.title)))])],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }